import React from "react";
import PropTypes from "prop-types";

import SignUp from "features/application/sign-up";
import SignInView from "features/application/sign-in/view";
import ResetPasswordView from "features/application/reset-password/view";
import CreatePasswordView from "features/application/create-password/view";
import ChangeEmailView from "features/application/change-email/view";

import "features/application/authentication/component/view.scss";

const AuthenticationView = ({
  responseCodes,
  errorCodes,
  currentStep,
  urlUserId,
  formReference,
  sendApiRequest,
}) => (
  <section
    className={`application__authentication authentication__${currentStep}`}
  >
    {currentStep === "sign-up" || currentStep === "referral" ? (
      <SignUp
        currentStep={currentStep}
        errorCodes={errorCodes}
        urlUserId={urlUserId}
        formReference={formReference}
        sendApiRequest={sendApiRequest}
      />
    ) : currentStep === "sign-in" ? (
      <SignInView
        responseCodes={responseCodes}
        errorCodes={errorCodes}
        formReference={formReference}
        sendApiRequest={sendApiRequest}
      />
    ) : currentStep === "reset-password" ? (
      <ResetPasswordView
        responseCodes={responseCodes}
        errorCodes={errorCodes}
        formReference={formReference}
        sendApiRequest={sendApiRequest}
      />
    ) : currentStep === "create-password" ? (
      <CreatePasswordView
        formReference={formReference}
        sendApiRequest={sendApiRequest}
      />
    ) : (
      currentStep === "change-email" && <ChangeEmailView />
    )}
  </section>
);

AuthenticationView.propTypes = {
  responseCodes: PropTypes.object,
  errorCodes: PropTypes.object,
  currentStep: PropTypes.string,
  urlUserId: PropTypes.string,
  formReference: PropTypes.object,
  sendApiRequest: PropTypes.func,
};

export default AuthenticationView;
